var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVBeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 19h14.394c2.4 0 4.238.62 5.517 1.862 1.29 1.242 1.935 2.779 1.935 4.611 0 1.538-.458 2.856-1.375 3.955-.611.733-1.505 1.313-2.682 1.738 1.788.45 3.1 1.224 3.938 2.324.849 1.087 1.273 2.46 1.273 4.114 0 1.348-.3 2.56-.9 3.636a6.78 6.78 0 0 1-2.46 2.554c-.646.39-1.62.674-2.92.851-1.732.237-2.88.355-3.446.355H21V19Zm7.757 10.198h3.344c1.2 0 2.031-.213 2.495-.639.476-.437.713-1.064.713-1.88 0-.756-.237-1.348-.713-1.773-.464-.426-1.278-.639-2.444-.639h-3.395v4.93Zm0 10.215h3.921c1.324 0 2.258-.242 2.801-.727.543-.496.815-1.158.815-1.986 0-.769-.272-1.384-.815-1.845-.532-.473-1.471-.709-2.818-.709h-3.904v5.267Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVBeth);
export default __webpack_public_path__ + "static/media/vBeth.8ea1040c21b42c41442cb6a5204e44a1.svg";
export { ForwardRef as ReactComponent };